(function (jQuery) {

    jQuery.fn.getVimeoAspectRatio = function () {
        // https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/518514675

        $this = jQuery(this);
        const url = $this.attr('src');
        return jQuery.ajax(`https://vimeo.com/api/oembed.json?url=${url}`)
            .then(data => data.width / data.height)
    }

    jQuery.fn.setWidthWindowHeight = function (videoRatio) {
        const $window = jQuery(window);
        const $this = jQuery(this);

        const windowRatio = $window.width() / $window.height();
        if (windowRatio <= videoRatio) {
            $this.height($window.height());
            $this.width(videoRatio * $window.height());
        } else {
            $this.width($window.width());
            $this.height($window.width() / videoRatio);
        }
    }

    const $loading = jQuery('#loading');
    const $welcomeIframe = jQuery('.welcome-background iframe');
    if ($welcomeIframe.length) {
        $welcomeIframe.each((index, element) => {
            const $element = jQuery(element);
            if ($element.parent().css('display') !== 'none') {
                const player = new Vimeo.Player(element);

                player.on('playing', function () {
                    $loading.addClass('loaded');
                })

                // Added timeout of 10s in case on event fails
                setTimeout(() => {
                    $loading.addClass('loaded');
                }, 10000)
            }


            $element.getVimeoAspectRatio()
                .then(videoRatio => {
                    $element.setWidthWindowHeight(videoRatio)
                    jQuery(window).on('resize', function () { $element.setWidthWindowHeight(videoRatio) });
                });
        })
    }

}(jQuery));